// extracted by mini-css-extract-plugin
module.exports = {"social":"Social-module--social--3-ECU","vertical":"Social-module--vertical--1VSp2","horizontal":"Social-module--horizontal--3t2vr"};